<template>
  <div class="fe-single-data-picker">
    <el-form-item
      :label="endTitle | capitalize"
      :class="{'is-required': isRequired || autoLimit }"
    >
    <el-date-picker
      v-model="defaultValue"
      :placeholder="placeholder"
      :disabled="disabled"
      :value-format="format"
      @blur="triggerVaildate"
      ref="input"
      :type="dateType"
      :picker-options="dataOptions"
      class="fe-single-data-picker-input-content"
    >
    </el-date-picker>
    <div
      class="el-form-item__error error_input"
      v-if="inForm && $v.defaultValue.$error">
    {{errorMessage}}
    </div>
    </el-form-item>
  </div>
</template>
<script>
  import validateMixin from '../../mixins/validateMixin'
  import baseMixin from './mixin/base'
  import moment from 'moment'
/* eslint-disable */
  // import _ from 'lodash'
/* eslint-disable */
  export default {
    name: 'fe-single-date-picker',
    mixins: [validateMixin, baseMixin],
    props: {
      format: {
        type: String,
        default: 'yyyy-MM-dd'
      },
      value: {
        type: String | Array
      },
      limit: {
        type: Number
      },
      quickCard: {
        type: Object
      },
      name: {
        type: String
      },
      params: {
        type: Object
      },
      nowTimeStamp: { // 时间范围组件新添加
        type: Number
      }
    },
    data() {
      this.dataOptions = {
        disabledDate: this.setDateRange,
        firstDayOfWeek: 1
      }
      return {
        defaultValue: '',
        preDefaultValue: '' // 上一个时间
      }
    },
    mounted() {
      console.log(this.validateRules)
      const _this = this
      if (this.params) { // 时间范围组件新添加
        this.$eventBus.$on(this.name + 'next' + this.nowTimeStamp, ()=> {
          this.defaultValue = this.preDefaultValue || ''
        })
        this.$eventBus.$on(this.params.name + this.nowTimeStamp, (val)=> {
          // 组件本身的type
          if (!val) {
            val = ''
          }
          if (!_this.defaultValue) {
            _this.defaultValue = ''
          }
          let typeSelf = this.params.type
          let startDate = moment(_this.defaultValue).valueOf()
          let endDate = moment(val).valueOf()
          if (typeSelf === 'start') {
            if (startDate > endDate) {
              _this.$eventBus.$emit(_this.params.name + 'next' + _this.nowTimeStamp )
              _this.$message({
                message: '开始时间不能大于结束时间',
                type: 'warning'
              })
            } else {
              const timeIntervalMS =  (this.params.timeInterval - 1) * 24 * 60 * 60 * 1000
              if ((startDate + timeIntervalMS) < endDate) {
                _this.$eventBus.$emit(_this.params.name + 'next' + _this.nowTimeStamp )
                _this.$message({
                  message: '选择的时间范围应在' + this.params.timeInterval + '天之间',
                  type: 'warning'
                })
              }
            }
          } else if (typeSelf === 'end') {
            if (startDate < endDate) {
              _this.$eventBus.$emit(_this.params.name + 'next' + _this.nowTimeStamp)
              _this.$message({
                message: '开始时间不能大于结束时间',
                type: 'warning'
              })
            } else {
              const timeIntervalMS =  (this.params.timeInterval - 1) * 24 * 60 * 60 * 1000
              if (startDate > (endDate + timeIntervalMS)) {
                _this.$eventBus.$emit(_this.params.name + 'next' + _this.nowTimeStamp )
                _this.$message({
                  message: '选择的时间范围应在' + this.params.timeInterval + '天之间',
                  type: 'warning'
                })
              }
            }
          }
        })
      }

    },
    computed: {
      dateType() {
        if (this.format.length < 12) {
          return 'date'
        } else {
          return 'datetime'
        }
      }
    },
    methods: {
      setDateRange(newDate) {
        let maxValue = (this.validate && this.validate.maxValue) || ''
        let minValue = (this.validate && this.validate.minValue) || ''
        if (this.quickCard) {
          const nowMax = moment()
          const nowMin = moment()
          const years = this.quickCard.years
          const months = this.quickCard.months
          const days = this.quickCard.days
          let beforeFlag = false
          let afterFlag = false
          if (years && !_.isEmpty(years)) {
            const before = years.before
            const after = years.after
            if (before !== undefined) {
              beforeFlag = true
              nowMin.subtract(before, 'years')
            }
            if (after !== undefined) {
              afterFlag = true
              nowMax.add(after, 'years')
            }
            /* nowMin.subtract(before, 'years')
             nowMax.add(after, 'years') */
          }
          if (months && !_.isEmpty(months)) {
            const before = months.before
            const after = months.after
            if (before !== undefined) {
              beforeFlag = true
              nowMin.subtract(before, 'months')
            }
            if (after !== undefined) {
              afterFlag = true
              nowMax.add(after, 'months')
            }
          }
          if (days && !_.isEmpty(days)) {
            const before = days.before
            const after = days.after
            if (before !== undefined) {
              beforeFlag = true
              nowMin.subtract(before, 'days')
            }
            if (after !== undefined) {
              afterFlag = true
              nowMax.add(after, 'days')
            }
          }
          if (beforeFlag) {
            minValue = nowMin
          }
          if (afterFlag) {
            maxValue = nowMax
          }
        }
        if (maxValue && minValue) {
          const max = moment(maxValue)
          const min = moment(minValue)
          return !((max > moment(newDate)) && moment(newDate) > min)
        } else if (maxValue) {
          const max = moment(maxValue)
          return !(max > moment(newDate))
        } else if (maxValue) {
          const min = moment(newDate)
          return !(moment(newDate) > min)
        } else {
          if (this.limit === 1) {
            return newDate.getTime() < (Date.now() - 86400000)
          } else {
            return false
          }
        }
      }
    },
    watch: {
      value: {
        handler(val) {
          if (process.env.PROJECT === 'bi' || process.env.PROJECT === 'app') {
            if (val) {
              this.preDefaultValue = this.defaultValue // 时间范围组件新添加
              this.defaultValue = val
            } else {
              this.preDefaultValue = this.defaultValue // 时间范围组件新添加
              this.defaultValue = moment().format('YYYY-MM-DD')
              this.$emit('input', this.defaultValue)
            }
          } else {
            this.preDefaultValue = this.defaultValue // 时间范围组件新添加
            this.defaultValue = val
          }
        },
        deep: true,
        immediate: true
      },
      defaultValue(val) {
        this.$eventBus.$emit(this.name + this.nowTimeStamp, val) // 时间范围组件新添加
        this.$emit('input', val)
      }
    }
  }
</script>
<style rel="stylesheet/scss" lang="scss">
  .fe-single-data-picker {
    width: unset;
    position: relative;
    margin-top: 5px;
    margin-bottom: 5px;
    .el-form-item {
      margin-bottom: 0px !important;
      &.s-required{
        &::before{
           content: "*";
           color: #f56c6c;
           margin-right: 4px;
           position: absolute;
           bottom: 5px;
           left:0;
         }
      }
    }
    label {
      font-size: 12px;
      width: 100px;
      line-height: 30px;
      display: inline-block;
    }
    .fe-single-data-picker-input-content {
      width: 178px;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/FromBase/datePicker.vue